import { __decorate } from "tslib";
import { module } from 'angular';
import { NgModule } from 'angular-ts-decorators';
import { ContactUsSpotController } from './contact-us-spot/contact-us-spot.controller';
import { ContactUsTabComponent } from './contact-us-tab/contact-us-tab.component';
import { ContactUsTabsComponent } from './contact-us-tabs/contact-us-tabs.component';
import { ContactSupportSectionController } from './contact-support-section/contact-support-section.controller';
import { ContactUsApiService } from './services/contact-us-api.service';
import { SupportDesignModule } from 'src/Foundation/Design/app';
var moduleId = 'gn.audio.support.contactsupport';
var legacyModuleId = moduleId + ".legacy";
module(legacyModuleId, [])
    .controller('ContactSupportSectionController', ContactSupportSectionController)
    .controller('ContactUsSpotController', ContactUsSpotController);
var ContactSupportModule = (function () {
    function ContactSupportModule() {
    }
    ContactSupportModule = __decorate([
        NgModule({
            declarations: [ContactUsTabComponent, ContactUsTabsComponent],
            id: moduleId,
            imports: [SupportDesignModule, legacyModuleId],
            providers: [ContactUsApiService],
        })
    ], ContactSupportModule);
    return ContactSupportModule;
}());
export { ContactSupportModule };
